var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("oceano-default-section", {
    staticClass: "menu--section-oceano_steak",
    attrs: {
      section: _vm.section,
      menu: _vm.menu,
      "section-modifier": "steak",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }